import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { searchCatalog } from "../services/api";
import "./CatalogSearch.css";
export default function CatalogSearch({ onAddItem, addedItemIds, }) {
    const { instance } = useMsal();
    const [searchTerm, setSearchTerm] = useState("");
    const [results, setResults] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [addingItemIds, setAddingItemIds] = useState(new Set());
    const [hasSearched, setHasSearched] = useState(false);
    const pageSize = 25;
    const doSearch = async (p) => {
        if (!searchTerm.trim())
            return;
        setLoading(true);
        try {
            const data = await searchCatalog(instance, searchTerm.trim(), p, pageSize);
            setResults(data);
            setPage(p);
            setHasSearched(true);
        }
        catch (err) {
            console.error("Catalog search failed:", err);
        }
        finally {
            setLoading(false);
        }
    };
    const handleSearch = () => {
        doSearch(1);
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter")
            handleSearch();
    };
    return (_jsxs("div", { className: "catalog-search", children: [_jsxs("div", { className: "search-row", children: [_jsx("input", { type: "text", placeholder: "Search catalog by identifier...", value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), onKeyDown: handleKeyDown }), _jsx("button", { onClick: handleSearch, disabled: loading, children: loading ? "Searching..." : "Search" })] }), hasSearched && results.length === 0 && !loading && (_jsx("p", { children: "No results found." })), results.length > 0 && (_jsxs(_Fragment, { children: [_jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Identifier" }), _jsx("th", { children: "Description" }), _jsx("th", {})] }) }), _jsx("tbody", { children: results.map((item) => (_jsxs("tr", { children: [_jsx("td", { children: item.identifier }), _jsx("td", { children: item.description }), _jsx("td", { children: addedItemIds.has(item.id) ? (_jsx("span", { style: { color: "#888", fontSize: "0.8rem" }, children: "Added" })) : addingItemIds.has(item.id) ? (_jsx("button", { className: "btn-add-item", disabled: true, children: "Adding..." })) : (_jsx("button", { className: "btn-add-item", onClick: async () => {
                                                    setAddingItemIds((prev) => new Set(prev).add(item.id));
                                                    try {
                                                        await onAddItem(item);
                                                    }
                                                    finally {
                                                        setAddingItemIds((prev) => {
                                                            const next = new Set(prev);
                                                            next.delete(item.id);
                                                            return next;
                                                        });
                                                    }
                                                }, children: "Add" })) })] }, item.id))) })] }), _jsxs("div", { className: "pagination", children: [_jsx("button", { disabled: page <= 1, onClick: () => doSearch(page - 1), children: "Previous" }), _jsxs("span", { children: ["Page ", page] }), _jsx("button", { disabled: results.length < pageSize, onClick: () => doSearch(page + 1), children: "Next" })] })] }))] }));
}
